import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'

import { _OverflowBox, _MobileArrow } from './styles'

/**
 * This component shows horizontal scroll bar with clickable color on overflow
 * Also hide arrow on scroll event
 */
class OverflowBox extends Component {
  constructor(props) {
    super(props)
    this.getContainerRef = this.getContainerRef.bind(this)
    this.scrollEventHandler = this.scrollEventHandler.bind(this)

    this.state = {
      showArrow: this.props.mobileBrowser && this.props.showInitArrow,
    }
  }

  componentWillUnmount() {
    if(this.elem) {
      this.elem.removeEventListener('scroll', this.scrollEventHandler)
    }
  }

  getContainerRef(ref) {
    if(ref) {
      this.elem = ref
      if(this.props.getRef) this.props.getRef(this.elem)
      if(this.state.showArrow) {
        this.elem.addEventListener('scroll', this.scrollEventHandler)
      }
    }
  }
  scrollEventHandler() {
    if(this.elem && this.state.showArrow) {
      this.elem.removeEventListener('scroll', this.scrollEventHandler)
    }
    this.setState({
      showArrow: false,
    })
  }

  render() {
    const { className, children } = this.props
    return (
      <_OverflowBox
        ref={this.getContainerRef}
        className={`${className}`}
      >
        {children}
        {
          this.state.showArrow && (
            <_MobileArrow>
              <SvgIcon name={'#icon-arrow'} width={30} height={30} />
            </_MobileArrow>
          )
        }
      </_OverflowBox>
    )
  }
}

OverflowBox.propTypes = {
  className: PropTypes.string,
  mobileBrowser: PropTypes.bool,
  showInitArrow: PropTypes.bool,
  getRef: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node]),
}

export default OverflowBox
